import {
  Breadcrumb, Button, Card, ErrorMessage,
} from 'nhsuk-react-components';
import { useNavigate } from 'react-router-dom';
import CampaignsTable from 'components/Home/CampaignsTable';
import useUser from 'hooks/useUser';
import ProgressIndicator from 'components/ProgressIndicator';
import useFetchCampaigns from 'queries/fetch/fetchCampaigns.ts';
import { getTeamIdFromRole, getWriteRoles } from 'utils/userUtils';
import featureFlags from 'services/featureFlags.ts';

export default function Campaigns() {
  const navigate = useNavigate();
  const { teamIds, roles } = useUser();
  const writeRoles = getWriteRoles(roles);
  const { data: campaigns, error: campaignsError, isFetching: campaignsIsFetching } = useFetchCampaigns({ teamIds });

  const createCampaignHandler = () => {
    const multipleTeamsWithWriteRole = writeRoles.length > 1;
    if (multipleTeamsWithWriteRole) {
      navigate('/select-team');
      return;
    }

    const [role] = writeRoles;
    const teamId = getTeamIdFromRole(role);

    navigate(`/${teamId}/campaign/new/key-details`);
  };

  const createCampaignFromTemplateHandler = () => {
    const multipleTeamsWithWriteRole = writeRoles.length > 1;
    if (multipleTeamsWithWriteRole) {
      navigate('/select-team?template');
      return;
    }

    const [role] = writeRoles;
    const teamId = getTeamIdFromRole(role);

    navigate(`/${teamId}/campaign/new/template-selection`);
  };

  return (
    <div className="nhsuk-u-margin-top-6">
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Manage campaigns</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <>
          <h1>
            Manage campaigns
          </h1>
          <p>
            You can view and edit a live or upcoming campaign created by you or your team. Click the campaign name for more information.
          </p>
        </>
      </Card>

      {writeRoles.length > 0 && (
        <Button
          className="nhsuk-u-margin-right-4"
          onClick={createCampaignHandler}
          aria-label="Create a new campaign"
        >
          Create a campaign
        </Button>
      )}

      {writeRoles.length > 0 && featureFlags.campaignTemplates && (
        <Button
          className="nhsuk-u-margin-right-4"
          onClick={createCampaignFromTemplateHandler}
          aria-label="Create a campaign from template"
        >
          Create a campaign from template
        </Button>
      )}

      {campaignsError && <ErrorMessage role="alert">There was an error getting the campaigns.</ErrorMessage>}

      {(!campaignsError && campaignsIsFetching) && <ProgressIndicator text="Loading campaigns" />}

      {campaigns && Object.keys(campaigns).map((teamId) => (
        <div className="nhsuk-u-margin-bottom-5" key={`campaigns-${teamId}`}>
          <CampaignsTable
            campaigns={Array.isArray(campaigns[teamId]) ? campaigns[teamId] : []}
            teamId={teamId}
            showTeamId
          />
        </div>
      ))}
    </div>
  );
}
